import { render, staticRenderFns } from "./viewDialog.vue?vue&type=template&id=606fe746"
import script from "./viewDialog.vue?vue&type=script&lang=js"
export * from "./viewDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('606fe746')) {
      api.createRecord('606fe746', component.options)
    } else {
      api.reload('606fe746', component.options)
    }
    module.hot.accept("./viewDialog.vue?vue&type=template&id=606fe746", function () {
      api.rerender('606fe746', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/csgOrder/internal/components/GoodsInfoTab/viewDialog.vue"
export default component.exports